import "./base.css"

import { FieldErrors, UseFormRegisterReturn } from "react-hook-form"
import React, { ReactNode } from "react"

import RadioStyles from "./radio.module.css"
import WrapWithError from "./wrap-with-error"
import classNames from "classnames"
import { useRequiredMark } from "./required-mark"

type RadioProps = {
    options: { value: string; label: ReactNode; extra?: ReactNode }[]
    error?: FieldErrors
    register: UseFormRegisterReturn
    required?: boolean
    label?: string
    flex?: boolean
}

const Radio = ({ options, error, register, required, label, flex }: RadioProps) => {
    const showRequiredMark = useRequiredMark()

    return (
        <fieldset
            className={classNames(RadioStyles.block, {
                [RadioStyles.flex]: flex,
                [RadioStyles.error]: error?.[register.name],
            })}
            aria-invalid={!!error?.[register.name]}
            aria-errormessage={"err-" + register.name}
        >
            {label && (
                <legend className={RadioStyles.label}>
                    {label}
                    {required && showRequiredMark && <span className="required"> *</span>}
                </legend>
            )}
            <WrapWithError error={error?.[register.name]} id={register.name}>
                {options.map(option => (
                    <div className={RadioStyles.radio} key={`${register.name}-${option.value}`}>
                        <input
                            {...register}
                            type="radio"
                            id={`${register.name}-${option.value}`}
                            value={option.value}
                            className="hiddenInput"
                            required={required}
                        />
                        <label htmlFor={`${register.name}-${option.value}`}>{option.label}</label>
                        {option.extra && <div className={RadioStyles.extra}>{option.extra}</div>}
                    </div>
                ))}
            </WrapWithError>
        </fieldset>
    )
}

export default Radio
